import axiosClient from 'config/axiosClient';

const _url = '/api/settings';

const settingService = {
    settingsSchedule: (numberOfDays) => {
        return axiosClient.post(_url + '/schedule', { numberOfDays: numberOfDays });
    },
    getSettingsSchedule: () => {
        return axiosClient.post(_url + '/get-schedule', {});
    },
    settingsAttendance: (status) => {
        return axiosClient.post(_url + '/set-attendance', { value: status ? 1 : 0 });
    },
    getSettingAttendance: () => {
        return axiosClient.post(_url + '/get-attendance', {});
    },
    settingsEvaluatuon: (status) => {
        return axiosClient.post(_url + '/set-evaluation', { value: status ? 1 : 0 });
    },
    getSettingEvaluation: () => {
        return axiosClient.post(_url + '/get-evaluation', {});
    },
    settingsOnlineExam: (status) => {
        return axiosClient.post(_url + '/set-online-exam', { value: status ? 1 : 0 });
    },
    getSettingOnlineExam: () => {
        return axiosClient.post(_url + '/get-online-exam', {});
    },
    getSettingPrint: () => {
        return axiosClient.post(_url + '/get-print-ticket', {});
    },
    settingPrint: (data) => {
        return axiosClient.post(_url + '/set-print-ticket', data);
    },
};

export default settingService;
